import { lazy, Suspense } from "react";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";

// Lazy load Footer as it's below the fold
const Footer = lazy(() => import("@/components/Footer"));

const Home = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
      </main>
      <Suspense fallback={<div className="h-64 bg-secondary" />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Home;
